import React, { useEffect } from 'react';
import './App.scss';
import ParticlesBackground from './components/ParticlesBackground';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';

function App() {
  useEffect(() => {
    if (window.WOW) {
      new window.WOW().init();
    }
  }, []);

  return (
    <>
      <ParticlesBackground />
      <div className="App container-fluid">
        <Hero />
        <AboutUs />
        <Contact />
      </div>
    </>
  );
}

export default App;
